import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=8d94d91c&"
import script from "./JobItem.vue?vue&type=script&lang=js&"
export * from "./JobItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports